import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //个人信息
    member:{
      real_name:'',
      introduction:'',
      head_pic:'',
    },
    //当前病例详情
    caseDetailValue:{},
    //顶部路由显示参数
    breadOption:{
      name:'',
      isBack:false,
      url:''
    },
    //请求状态
    workState:true,
   //设计单参数
    designOption:{
      shejidan_type: '',
      shejidan_img: '',
      patient_id: '',
      cycleType: ''
    },
    // 顶部铃铛小红点显示
    topBellRedDotShow: false,
  },
  mutations: {
    memberChange(state,data){
      state.member = data
    },
    breadChange(state,data){
      state.breadOption = data
    },
    caseDetailValueChange(state,data){
      state.caseDetailValue = data
    },
    designOptionChange(state,data){
      state.designOption = data
      // return Promise.resolve()
    },
    workStart(state){
      state.workState = false
    },
    workOver(state){
      state.workState = true
    },
    setTopBellRedDotShow(state, topBellRedDotShow) {
      state.topBellRedDotShow = topBellRedDotShow
    }
  },
  actions: {

  },
  modules: {

  }
})
